import {capitalize} from './utils';

const SUPPORTED_IE_VERSION = 10;

/**
 * Browser and user agent utilities
 */

var ua = (window)?window.navigator.userAgent:'';

// Internal methods

/**
 * Returns user agent classes as array
 * Used mainly with "applyUAClasses" but not exported
 * @returns {Array}
 */

function getUAClasses(userAgentString = ua){
	let uaName       = getUserAgentName(userAgentString),
		uaVer        = getUserAgentVersion(userAgentString),
		deviceFamily = getDeviceFamily(userAgentString),
		deviceVer    = getDeviceVersion(userAgentString),
		uaClasses    = [];

	if(deviceFamily){
		deviceFamily = "ua"+capitalize(deviceFamily);
		uaClasses.push(deviceFamily);
		if(deviceVer) uaClasses.push(deviceFamily+deviceVer);
	}

	if(uaName){
		uaName = "ua"+capitalize(uaName);
		uaClasses.push( uaName );
		if(uaVer)  uaClasses.push(uaName+uaVer);
	}

	return uaClasses;
}


/**
 * Apply user agent classes on the client due to server-side page caching
 */
export function applyUAClasses(){
	$('html').addClass( getUAClasses().join(" ") );
}


/**
 * Returns the device family
 * @param {string} userAgentString
 * @return {string}
 */
export function getDeviceFamily(userAgentString){
	if(userAgentString.indexOf('iPhone')>-1){
		return "iphone";
	} else if(userAgentString.indexOf('iPad')>-1){
		return "ipad";
	} else if(userAgentString.indexOf('Android')>-1) {
		return 'android';
	} else if(userAgentString.indexOf('Windows')>-1) {
		return 'windows';
	} else if(userAgentString.indexOf('Mac OS X')>-1) {
		return 'mac';
	} else if(isMobile()){
		return "mobile";
	} else {
		return "desktop";
	}
}

/**
 * Returns the device version
 * @param {string} userAgentString
 * @return {string}
 */
export function getDeviceVersion(userAgentString){

	let deviceVer;

	if(userAgentString.indexOf('iPhone')>-1){
		deviceVer = userAgentString.substring(userAgentString.indexOf('iPhone OS')+10).trim().split("_").join(".");
	} else if(userAgentString.indexOf('Android')>-1){
		deviceVer =  userAgentString.substring(userAgentString.indexOf('Android')+8).trim();
	} else if(userAgentString.indexOf('Windows')>-1){
		deviceVer =  userAgentString.substring(userAgentString.indexOf('Windows Phone')+14).trim();
	}

	if(deviceVer){
		if(deviceVer.indexOf(" ")>0) deviceVer = deviceVer.substring(0, deviceVer.indexOf(" "));
		if(deviceVer.indexOf(".")>0) deviceVer = deviceVer.substring(0, deviceVer.indexOf("."));
	}

	return deviceVer;
}


/**
 * Returns the browser name from the user agent
 * @param {string} userAgentString
 * @returns {string}
 */
export function getUserAgentName(userAgentString){
	if(userAgentString.indexOf('CriOS')>-1) {
		return 'chrome';
	}else if(userAgentString.indexOf('Chrome')>-1){
		return 'chrome';
	} else if(userAgentString.indexOf('Safari')>-1){
		return 'safari';
	} else if(userAgentString.indexOf('Firefox')>-1){
		return 'firefox';
	} else if(userAgentString.indexOf('MSIE')>-1){
		return 'MSIE';
	} else if(/Trident.*rv[ :]*11\./.test(userAgentString)){
		return 'MSIE';
	} else if(userAgentString.indexOf('Opera')>-1){
		return 'opera';
	} else if(userAgentString.indexOf('FB_IAB')>-1){
		return 'FBInternal';
	} else if (userAgentString.indexOf('AppleWebKit') > -1) {
		// This particular case is for WKWebView in iPads. They use another UserAgent (without text 'iPad')
		return 'WKWebView';
	} else {
		// We must return a string in the event we can't detect the browser name,
		// calling code is expecting to run a method from the String prototype on the result.
		return '';
	}
}

/**
 * Returns the browser version number from the user agent
 * @param {string} userAgentString
 * @returns {string}
 */
export function getUserAgentVersion(userAgentString){
	let uaVer;
	if(userAgentString.indexOf('Chrome')>-1){
		uaVer = userAgentString.substring(userAgentString.indexOf('Chrome')+7).trim();
	} else if(userAgentString.indexOf('Safari')>-1){
		uaVer = userAgentString.substring(userAgentString.indexOf('Version')+8).trim();
	} else if(userAgentString.indexOf('Firefox')>-1){
		uaVer = userAgentString.substring(userAgentString.indexOf('Firefox')+8).trim();
	} else if(userAgentString.indexOf('MSIE')>-1){
		uaVer = userAgentString.substring(userAgentString.indexOf('MSIE')+5).trim();
	} else if(/Trident.*rv[ :]*11\./.test(userAgentString)){
		uaVer = '11';
	} else if(userAgentString.indexOf('Opera')>-1){
		uaVer = userAgentString.substring(userAgentString.indexOf('Opera')+6).trim();
	}

	if(uaVer){
		if(uaVer.indexOf(" ")>0) uaVer = uaVer.substring(0, uaVer.indexOf(" "));
		if(uaVer.indexOf(".")>0) uaVer = uaVer.substring(0, uaVer.indexOf("."));
	}

	return uaVer;
}

/**
 * Quick and dirty browser checks
 * @returns {boolean}
 */

export function isWebkit(){
	return ('webkitRequestAnimationFrame' in window);
}

export function isIE(){
	return (/MSIE/.test(ua) || /Trident.*rv[ :]*11\./.test(ua));
}

export function isEdge(){
	return /Edge/.test(ua);
}

export function isIEMobile(){
	return /IEMobile/.test(ua);
}

export function isSafari() {
	return /Safari/.test(ua) && /Apple Computer/.test(navigator.vendor);
}

export function isFirefox() {
	return /Firefox/.test(navigator.vendor);
}

export function isChromeIOS() {
	return /CriOS/.test(ua);
}

// Internal in-app browsers for FB + Twitter cause a bunch of issues
export function isFBInternal(){
	return (/FB_IAB/.test(ua) || /FBIOS/.test(ua))
}

export function isTwitterInternal(){
	return /Twitter for iPhone/.test(ua)
}

// check for mobile device by orientation.
// * has a userAgent failover because windows mobile doesn't support window.orientation
// * over-sized tablets will likely trigger this too but we cannot rely on the resolution to identify a mobile device.
export function isMobile(){
	return (window && ('orientation' in window) || isIEMobile());
}


// For Helios, we only support IE10+, Chrome, Safari, Opera and Firefox
// For NON-Helios, we only support IE9+, Chrome, Safari, Opera and Firefox
export function isSupportedBrowser(userAgentString = ua, helios = true){

	let device  = getDeviceFamily(userAgentString).toLowerCase(),
		agent   = getUserAgentName(userAgentString).toLowerCase(),
		version = parseInt(getUserAgentVersion(userAgentString),10);

	//log.debug("Device: "+device+"; Agent: "+agent+"; Version: "+version,6);

	if( ['android', 'iphone', 'ipad'].indexOf(device) > -1 ) return true;
	if( ['chrome','opera','firefox','safari', 'wkwebview'].indexOf(agent)>-1 ) return true;
	if(helios && (agent === "msie" && version>=SUPPORTED_IE_VERSION)) return true;
	if(!helios && (agent === "msie" && version>=(SUPPORTED_IE_VERSION-1))) return true;

	return false;

}


/**
 * Checks if browser supports upload fields
 * @returns {boolean}
 */

export function supportsUpload(){

	let html = document.documentElement || document.getElementsByTagName('html')[0];

	if(html && html.hasAttribute('class') && !/\bfileinput\b/g.test(html.getAttribute('class'))
		||
		(isIEMobile() && /uaMSIE10/.test(html.getAttribute('class')))
		||
		(isFBInternal() && /uaAndroid/.test(html.getAttribute('class')) && (getDeviceVersion(ua) <= 4.4)) ) {

		return false;
	}

	return true

}

/**
 * Open a new window with url and an optional query string
 * @param {string} url
 * @param {object} obj
 * @returns {boolean}
 */

export function openWindow(url, obj) {
	if (url) {
		if (obj) {
			url += '?' + $.param(obj);
		}
		window.open('//' + url, '_blank', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
	}
	return false;
}

/**
 * Return the queryString as an object, if a parameter is supplied return that value
 * @param {string} param
 * @param {string} [url] - override window.location
 * @returns {string}
 */
//
export function queryStringObject(param,url) {
	var qs = (url)?url.substring(url.indexOf('?')):window.location.search,
		out = {};
	if (qs) {
		_.each(qs.slice(1).split('&'), function(item){
			var kvp = item.split('=');
			out[kvp[0]] = kvp[1] || undefined;
		});
	}
	return (typeof param === 'string')? out[param]: out;
}

/**
 * Adds items to current page's query string, or on fullUrl if given
 * @param {object} newParams
 * @param {boolean} replaceIfExists
 * @param {string} fullUrl
 * @returns {string}
 */

export function updateQueryString(newParams,replaceIfExists,fullUrl){
	var _newParams = newParams||{},
		_replace   = (!!replaceIfExists===false)?false:true,
		_qUrl      = ((fullUrl==='ctx:smarturl')?NGX.context.smarturl:fullUrl)||document.location.href,
		_hasQS     = ( _qUrl.indexOf('?')>-1 )?true:false,
		_qString   = _hasQS?_qUrl.substring(_qUrl.indexOf('?')+1):"",
		_qSObj     = {},
		_newQSObj  = {};

	if(_qString){
		_.each(_qString.split('&'), function(item){
			var kvp = item.split('=');
			_qSObj[kvp[0]] = kvp[1] || undefined;
		});
	}

	if(_replace){
		_.extend(_newQSObj,_qSObj,_newParams);
	} else {
		_.extend(_newQSObj,_newParams,_qSObj);
	}

	if(_hasQS) _qUrl = _qUrl.substring(0,_qUrl.indexOf('?'));

	return _qUrl+"?"+decodeURIComponent($.param(_newQSObj));
}


/**
 * Retrieves the parent page's URL and parses the query string
 * @param [callback] optional callback to call, passing the params as an object
 */
export function getParentParams(callback){
	NGX.App.api.messageParent({action:'getpageinfo'},function(info){
		let _params = queryStringObject(null,info.url);
		let _pageInfo = Object.assign({},NGX.App.state.pageInfo,{parentParams:_params});

		NGX.App.state.pageInfo = _pageInfo;

		if(typeof callback === "function"){
			callback.call(this,_params);
		}

	})
}
